var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetQuiker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "#FEF9EB",
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6665 40H34.6665M42.6665 40C44.1393 40 45.3332 41.1939 45.3332 42.6667C45.3332 44.1394 44.1393 45.3333 42.6665 45.3333H34.6665C33.1937 45.3333 31.9998 44.1394 31.9998 42.6667C31.9998 41.1939 33.1937 40 34.6665 40M42.6665 40C44.1393 40 45.3332 38.8061 45.3332 37.3333C45.3332 35.8606 44.1393 34.6667 42.6665 34.6667H41.7776M34.6665 40C33.1937 40 31.9998 38.8061 31.9998 37.3333C31.9998 35.8606 33.1937 34.6667 34.6665 34.6667H41.7776M34.2338 45.3333H29.7659C24.3054 45.3333 20.4497 39.9838 22.1764 34.8035L23.5098 30.8035C24.5987 27.5368 27.6558 25.3333 31.0992 25.3333H32.9004C36.3439 25.3333 39.401 27.5368 40.4899 30.8035L41.7776 34.6667",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.781 25.3333L29.2187 25.3333L27.3505 23.1906C25.5193 21.0902 27.6556 17.9506 30.3293 18.8131L31.5663 19.2122C31.8479 19.303 32.1517 19.303 32.4334 19.2122L33.6704 18.8131C36.344 17.9506 38.4804 21.0902 36.6491 23.1906L34.781 25.3333Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetQuiker);
export default __webpack_public_path__ + "static/media/getQuiker.986d9cf86dbf01c6936c6f34079e5b3c.svg";
export { ForwardRef as ReactComponent };